import { Component, OnInit, Input } from '@angular/core';
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';

@Component({
  selector: 'app-view-user-details',
  templateUrl: './view-user-details.component.html',
  styleUrls: ['./view-user-details.component.css', '../../../../../assets/css/custom-egd.css']
})
export class ViewUserDetailsComponent implements OnInit {
  slug: string = "";
  constructor(private readonly breadcrumbService: DoctorBreadcrumbService,
              private readonly providerstateService: ProviderStateService
  ) {
    
  }

  async ngOnInit() {
    this.slug = this.providerstateService.getProviderSlug();
    this.breadcrumbService.setItems([
      { label: 'Dashboard', routerLink:['/', this.slug, 'vendor'] },
      { label: 'View Details' },
      { label: 'Vendor' }
    ]);
   
  }

}
